// extracted by mini-css-extract-plugin
export default {"msgM":"_059f6cd799"};